<ng-template #ProfileHeaderSkeleton>
  <div class="row">
    <div class="shine" style="width: 100%; height: 142px;">
      <div class="dummy-wrapper">
        <div class="circle"></div>
        <div class="dummy-column">
          <div class="mb-20 dummy-content"></div>
          <div class="dummy-content"></div>
        </div>
        <div class="dummy-column">
          <div class="mb-20 dummy-content"></div>
          <div class="dummy-content"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

@if (showLoading) {
  <ng-template [ngTemplateOutlet]="ProfileHeaderSkeleton"></ng-template>
}

@if (!showLoading) {
  @if (customer) {
    <div class="profile-wrapper">
      <div class="profile-cont">
        <div class="profile-cont-left">
          <div class="circle">
            <div class="profile-icon"></div>
          </div>
          <div class="profile-cont-col">
            <div class="mb-20">
              <span>Name:  </span>
              <span>{{ customer.name }}</span>
            </div>
            <div>
              <span>Phone:  </span>
              <span>{{ customer.phone_no }}</span>
            </div>
          </div>
          <div class="profile-cont-col">
            <div class="mb-20" [style.visibility]="customer?.email ? 'visible' : 'hidden'">
              <span>Email:  </span>
              <span>{{ customer.email }}</span>
            </div>
            <div [style.visibility]="customer?.customer_info?.birthday ? 'visible' : 'hidden'">
              <span>DOB: </span>
              @if (customer?.customer_info?.birthday) {
                <span>{{ formatBirthday() }}</span>
              }
            </div>
          </div>
        </div>
        <div class="profile-cont-right">
          <div class="mb-20">
            <button btn-border size="full" class="profile-edit-btn" (click)="openProfileDialog()">Edit</button>
          </div>
        </div>
      </div>
    </div>
  }
}
